module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedThin.334eaec.ttf";